<template>
    <v-container>
      <div>
          <v-row justify="space-between">
              <v-col cols="12" sm="6" justify="center">
                  <p class="header-title"> {{$t('metric.title')}} </p>
              </v-col>

              <v-col cols="12" sm="6" justify="center" class="pr-5">
              </v-col>
          </v-row>
      </div>
      <v-data-table :headers="headers" :items="desserts" :search="search" sort-by="email" :loading="loading" class="elevation-1" hide-default-footer :page.sync="page" :items-per-page="itemsPerPage"  @page-count="pageCount = $event">
        <template v-slot:top>
          <v-toolbar flat color="white" class="pt-5">
            <v-row justify="start">
              <v-col cols="12" sm="1">
                  <v-autocomplete v-model="itemsPerPage" :items="numberPage" outlined :dense="true"></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="2">
              </v-col>
              
              <v-col cols="12" sm="2">
              </v-col>

              <v-col cols="12" sm="7">
                  <v-text-field v-model="search" append-icon="search" v-bind:label="$t('common.search')" single-line hide-details outlined :dense="true"></v-text-field>
              </v-col>
            </v-row>
          </v-toolbar>
        </template>

        <template v-slot:[`item.action`]="{ item }">
            <v-icon  small class="mr-2"  @click="editItem(item)">
                edit
            </v-icon>
            <!-- <v-icon  small @click="deleteItem(item)">
                delete
            </v-icon> -->

        </template>

        <template v-slot:no-data>
        </template>
      </v-data-table>

      <div class="text-center pt-2">
        <v-pagination v-model="page" :length="pageCount"></v-pagination>
      </div>
    </v-container>
</template>

<script>
  import i18n from '@/plugins/i18n';
  // import VNumericField from "@/components/VNumericField";

  export default {
    data: () => ({
      mouseEvent: null,
      editEvent: null,
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,

      loading: true,
      numberPage: [
        5, 10, 15, 20, 25
      ],

      selectFormStyle: null,
      metrics: {},
      search: '',
      dialog: false,

      headers: [{ text: '#', align: 'left', sortable: false, value: 'formStyle.code'}],
      materials: [],
      formStyles: [],
      desserts: [],
      editedIndex: -1,
      editedItem: {},
      defaultItem: {},
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? i18n.t('metric.add') : i18n.t('metric.edit')
      }
    },

    components: {
      //  VNumericField: VNumericField
    },


    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      this.initialize()
    },

    mounted () {
      
    },

    methods: {
      async initialize () {
        await this.getMaterialData(),
        await this.getFormStyleData(),
        await this.createHeaderData(),
        await this.getData()
      },

      editItem (item) {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.selectFormStyle = this.editedItem.formStyle;
        this.dialog = true
      },

     async deleteItem (item) {
        const agree = confirm(i18n.t('common.confirm_delete'))
        if (agree) {
          const response =  await this.$http.delete('/metric/formStyle/' + item.formStyle._id);
          if(response.data && response.data.success) {
              this.desserts.splice(item.index - 1, 1);
              this.desserts.forEach((item, index) =>item.index = index + 1);
          } else if(response.data && !response.data.success) {
              alert(i18n.t(response.data.message));
          } else {
              alert(i18n.t('validate.request_error'));
          }
        }
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      async save () {
        if (this.editedIndex > -1) {
          try {
            const requestBody =  this.editedItem;
            const response = await this.$http.put('/metric', requestBody);

            if (response.data && response.data.success) {
                Object.assign(this.desserts[this.editedIndex], this.editedItem);
                self.editedItem = {};

                this.$fire({
                    title: i18n.t('common.update_success'),
                    text: "",
                    type: "success"
                    }).then(() => {
                        
                });
            } else if(response.data && !response.data.success) {
                alert(i18n.t(response.data.message));
            } else {
                alert(i18n.t('validate.request_error'));
            }
          } catch (e) {
              console.log(e.stack);
              alert(i18n.t('validate.request_error'));
          }
        } else {
          try {
            const requestBody = this.editedItem;
            requestBody.formStyle = this.selectFormStyle._id;
            
            const response = await this.$http.post('/metric', requestBody);
            if (response.data && response.data.success) {
                // console.log(requestBody);
                this.editedItem.formStyle = this.selectFormStyle;
                this.desserts.push(this.editedItem);
                self.editedItem.index = this.desserts.length;
                self.editedItem = {};

                this.$fire({
                    title: i18n.t('common.success'),
                    text: "",
                    type: "success"
                    }).then(() => {
                        
                });
            } else if(response.data && !response.data.success) {
                alert(i18n.t(response.data.message));
            } else {
                alert(i18n.t('validate.request_error'));
            }
          } catch (e) {
              console.log(e.stack);
              alert(i18n.t('validate.request_error'));
          }
        }
        this.close()
      },

      async getMaterialData() {
        try {
            const response = await this.$http.get('/material');
            if (response.data && response.data.success) {
              this.materials = response.data.data;
            }
        } catch (e) {
            console.log(e.stack);
        }
      },

      async getFormStyleData() {
        try {
            const response = await this.$http.get('/formStyle');
            if (response.data && response.data.success) {
              this.formStyles = response.data.data;

              if (this.formStyles.length > 0) {
                this.selectFormStyle = this.formStyles[0];
              }
            }
        } catch (e) {
            console.log(e.stack);
        }
      },

      async createHeaderData() {
        const self = this;
        try {
          if (Array.isArray(self.materials) && self.materials.length > 0) {
            this.materials.forEach(item => {
              const data = {
                value: item._id,
                text: item.name + '(' + item.code + ')',
                sortable: false
              }
              self.headers.push(data)
            });
          }

          self.headers.push({ text: '', value: 'action', sortable: false })
        } catch (e) {
            console.log(e.stack);
        }
      },

      async getData() {
        try {
            const response = await this.$http.get('/metric');
            if (response.data && response.data.success) {
                let contextArr = response.data.data;
                contextArr.forEach((item, index) =>item.index = index + 1);
                this.desserts = contextArr;
                this.loading = false;
            }
        } catch (e) {
            console.log(e.stack);
        }
      },

      thousandSeprator(amount) {
        if (amount !== '' || amount !== undefined || amount !== 0  || amount !== '0' || amount !== null) {
          return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        } else {
            return amount;
        }
      }
    },
  }
</script>